import React, { PropsWithChildren } from 'react';
import {
  AddAppletContainer,
  AppletPreviewButton,
  AppletPreviewContainer,
  ContainerIcon,
} from '../../components';
import AddAppletIcon from './AddAppletIcon';

export const ALL_ID_ORDER = 900;

type QuestSectionProps = {
  onAddAppletClick: () => void;
};

const QuestSection = ({
  onAddAppletClick,
  children,
}: PropsWithChildren<QuestSectionProps>) => {
  const handleOpenAddApplet = () => onAddAppletClick();


  return (
    <ContainerIcon>
      {children}
      <AppletPreviewContainer width="146px" margin="10px">
        <AppletPreviewButton
          onClick={handleOpenAddApplet}
          height="139px"
          width="146px">
          <AddAppletContainer>
            <AddAppletIcon />
          </AddAppletContainer>
        </AppletPreviewButton>
      </AppletPreviewContainer>
    </ContainerIcon>
  );
};

export default QuestSection;
